// extracted by mini-css-extract-plugin
module.exports = {"hotels-map":"hotels-map_component_hotels-map__czZtG"};